import React, { useCallback, useMemo } from 'react';
import { useReactiveVar } from '@apollo/client';
import { hierarchyInEditRootIdVar, shouldRefetchListVar } from '../variables';
import HierarchyEditContainer from './edit/HierarchyEditContainer';
import SimpleDialog from 'components/common/dialog/SimpleDialog';
import { citiesStore } from '../store';
import { useTranslation } from 'react-i18next';
import { parseId } from 'utils/functions';

const HierarchyModalComponent = () => {
  const { t } = useTranslation();
  const hierarchyInEditRootId = useReactiveVar(hierarchyInEditRootIdVar);

  const handleClose = useCallback(() => {
    hierarchyInEditRootIdVar(null);
    const shouldRefetchList = shouldRefetchListVar();
    if (shouldRefetchList) {
      const store = citiesStore.get();
      store.refetch();
      shouldRefetchListVar(false);
    }
  }, []);

  const isNew = useMemo(() => Boolean(hierarchyInEditRootId) && !parseId(hierarchyInEditRootId), [hierarchyInEditRootId]);

  return (
    <SimpleDialog
      open={Boolean(hierarchyInEditRootId)}
      onClose={handleClose}
      size='lg'
      withCloseButton
      title={t(isNew ? 'City.AddingCountry' : 'City.EditingCountry')}
      content={<HierarchyEditContainer id={hierarchyInEditRootId} />}
      disableBackdropClick
    />
  );
};

export default HierarchyModalComponent;
